import { gql } from "@apollo/client";

export const SERVICE_EN_DIRECT_SEARCH_POSTAL_CODES = gql`
  query ServiceEnDirectSearchPostalCodes($q: String!) {
    serviceEnDirectSearchPostalCodes(q: $q) {
      id
      postal_code
      city
    }
  }
`;

export const SERVICE_EN_DIRECT_CARRIER = gql`
  query ServiceEnDirectCarrier($id: ID) {
    serviceEnDirectCarrier(id: $id) {
      id
      name
      code
      paywall_enabled
      deposit_amount
      minute_rate
      service_en_direct_article_list_id
      stripe_connected
      google_maps_api_key
      logo_url
      footer_logo_url
      office_name
      office_address
      office_email
      services {
        id
        code
        name
        assembly_time
        price
        is_service_category
      }
    }
  }
`;

export const SERVICE_EN_DIRECT_CHECK_ADDRESS = gql`
  query ServiceEnDirectCheckAddress(
    $address: ServiceEnDirectAddressInput!
  ) {
    serviceEnDirectCheckAddress(address: $address) {
      covered
      postal_code_id
      area_id
      office_id
      contractor_id
      contractor_name
    }
  }
`;

export const SERVICE_EN_DIRECT_QUOTE = gql`
  query ServiceEnDirectQuote($article_ids: [ID!]!) {
    serviceEnDirectQuote(article_ids: $article_ids) {
      lines {
        article_id
        name
        assembly_time
        price
      }
      total_price
      deposit_amount
      paywall_enabled
    }
  }
`;

export const SERVICE_EN_DIRECT_PLANNING = gql`
  query ServiceEnDirectPlanning(
    $postal_code_id: ID!
    $article_ids: [ID!]!
    $weeks: Int
    $contractor_id: ID
  ) {
    serviceEnDirectPlanning(
      postal_code_id: $postal_code_id
      article_ids: $article_ids
      weeks: $weeks
      contractor_id: $contractor_id
    ) {
      slots {
        date
        halfday
        office_id
        hour_from
        hour_to
        is_available
        fill_percentage
        is_next_day
        is_after_work
        has_extra_price
        extra_price
        unavailability_reasons
      }
      hide_planning_capacity
    }
  }
`;

export const SERVICE_EN_DIRECT_RESERVE = gql`
  mutation ServiceEnDirectReserve($input: ServiceEnDirectReserveInput!) {
    serviceEnDirectReserve(input: $input) {
      reservation_id
      expires_at
    }
  }
`;

export const SERVICE_EN_DIRECT_START_CHECKOUT = gql`
  mutation ServiceEnDirectStartCheckout(
    $reservation_id: ID!
    $success_url: String!
    $cancel_url: String!
  ) {
    serviceEnDirectStartCheckout(
      reservation_id: $reservation_id
      success_url: $success_url
      cancel_url: $cancel_url
    ) {
      checkout_url
      reservation_id
    }
  }
`;

export const SERVICE_EN_DIRECT_CONFIRM_FREE = gql`
  mutation ServiceEnDirectConfirmFree($reservation_id: ID!) {
    serviceEnDirectConfirmFree(reservation_id: $reservation_id) {
      order_id
      xct_token
    }
  }
`;

export const SERVICE_EN_DIRECT_FINALIZE_PAYMENT = gql`
  mutation ServiceEnDirectFinalizePayment($reservation_id: ID!) {
    serviceEnDirectFinalizePayment(reservation_id: $reservation_id) {
      order_id
      xct_token
      paid
    }
  }
`;
